<template>
  <section id="header-image">
    <div
      id="carouselExampleIndicators"
      class="carousel slide"
      data-ride="carousel"
    >
      <div class="carousel-inner">
        <div class="carousel-item active">
          <img
            src="https://snippcheck.blob.core.windows.net/files/wkkc_special_k_athletic_2007824/home-slider.jpg"
            class="d-none d-md-block img-fluid w-100"
            alt="WKKC_Athletic_Apparel"
          />
          <img
            src="https://snippcheck.blob.core.windows.net/files/wkkc_special_k_athletic_2007824/home-mobile-slider.jpg"
            class="d-md-none img-fluid w-100"
            alt="WKKC_Athletic_Apparel"
          />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {};
</script>
<style scoped></style>
